import type { CustomFilterProps } from "ag-grid-react";
import React from "react";
import { useSelector } from "react-redux";
import GroupName from "src/components/Group/Name";
import { getAllGroupsById, getGroupsByUsers } from "src/reducers";
import type { State } from "src/types";
import MultiSelectFilter from "src/components/AgGrid/Filters/MultiSelectFilter";

const GroupFilter = (props: CustomFilterProps): React.ReactElement => {
  const groupsByUser = useSelector(({ app }: State) => getGroupsByUsers(app));
  const groupsById = useSelector(({ app }: State) => getAllGroupsById(app));
  const data = { groupsByUser, groupsById };

  return (
    <MultiSelectFilter
      {...props}
      filterType="group"
      data={data}
      getValueFromData={(data, uid: any) => data.groupsByUser[uid] || []}
      getSearchText={(groupId) => data.groupsById[Number(groupId)]?.title || ""}
      renderValue={(groupId) => <GroupName id={Number(groupId)} />}
    />
  );
};

export default GroupFilter;
